import { createApp } from "vue";
import App from "./App.vue";
import VueCryptojs from "vue-cryptojs";

const app = createApp(App);
app.use(VueCryptojs);
app.mount("#app");
